if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (this.submitButton && document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        // Support both class names: Dawn uses .loading__spinner, custom themes may use .loading-overlay__spinner
        var spinner = this.querySelector('.loading__spinner') || this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData(this.form);

        // Only append sections if cart element exists and has the method
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        var self = this;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error response (e.g. 422 out of stock)
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              self.handleErrorMessage(response.description);

              var soldOutMessage = self.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              self.submitButton.setAttribute('aria-disabled', true);
              if (self.submitButtonText) self.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              self.error = true;
              return;
            }

            // SUCCESS — product was added to cart

            // If no cart element, try the custom drawer, else redirect
            if (!self.cart) {
              if (window.hsCart) {
                window.hsCart.open();
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            // Publish cart update event if available
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              var startMarker = (typeof CartPerformance !== 'undefined' && CartPerformance.createStartingMarker)
                ? CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;

              if (!self.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  if (startMarker && typeof CartPerformance !== 'undefined') {
                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                  }
                });
              }
            }
            self.error = false;

            var quickAddModal = self.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (self.cart && typeof self.cart.renderContents === 'function') {
                      self.cart.renderContents(response);
                    } else if (window.hsCart) {
                      window.hsCart.open();
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (self.cart && typeof self.cart.renderContents === 'function') {
                self.cart.renderContents(response);
              } else if (window.hsCart) {
                window.hsCart.open();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (self.submitButton) self.submitButton.classList.remove('loading');
            if (self.cart && self.cart.classList && self.cart.classList.contains('is-empty')) {
              self.cart.classList.remove('is-empty');
            }
            if (!self.error && self.submitButton) self.submitButton.removeAttribute('aria-disabled');

            var spinnerFinal = self.querySelector('.loading__spinner') || self.querySelector('.loading-overlay__spinner');
            if (spinnerFinal) spinnerFinal.classList.add('hidden');

            if (typeof CartPerformance !== 'undefined' && CartPerformance.measureFromEvent) {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to Cart';
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}